<template>
  <section>
    <q-list bordered separator>
      <q-item
        clickable
        v-ripple
      >
        <q-item-section @click="goToLKTest">
          ECOHOSPITAL
        </q-item-section>
      </q-item>
      <q-item
        clickable
        v-ripple
      >
        <q-item-section @click="goToDevPro">
          DEV Medsafe PRO
        </q-item-section>
      </q-item>
      <q-item
        clickable
        v-ripple
      >
        <q-item-section @click="goToDevDoctor">
          DEV Medsafe DOCTOR
        </q-item-section>
      </q-item>
      <!-- <q-item
        clickable
        v-ripple
        v-for="app in getAvailableApps"
        :key="app.id_app"
      >
        <q-item-section>{{ app.name_app }}</q-item-section>
      </q-item> -->
    </q-list>
  </section>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent, ref, onMounted } from 'vue';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';

export default { name: 'AppListView' };
</script>

<script setup lang="ts">
onMounted(() => {
  console.log('AppListView mounted');
});

const store = useAuthStore();
const { getAvailableApps } = storeToRefs(store);

const goToLKTest = () => {
  window.open('https://ecohospital.ru/redirect-login', '_blank');
};
const goToDevPro = () => {
  window.open('https://dev.medsafe.pro/redirect-login', '_blank');
};
const goToDevDoctor = () => {
  window.open('https://dev.medsafe.doctor/#/redirect-login', '_blank');
};
</script>
